import axios from "axios";
export default {
    getPasswordPolicy: () => axios.post("/PasswordPolicy/GetPasswordPolicy", {}),
    savePasswordPolicy: (changes) => axios.post("/PasswordPolicy/SavePasswordPolicy", changes)
};
